var a = /* @__PURE__ */ ((e) => (e.ADDED = "added", e.UPLOADING = "uploading", e.CANCELLED = "cancelled", e.FINISHED = "finished", e.ERROR = "error", e.ABORTED = "aborted", e))(a || {});
const p = {
  /**
   * Excel/csv file extensions
   */
  excel: [
    ".csv",
    "text/csv",
    "text/comma-separated-values",
    // works in Opera only for CSV
    "application/csv",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.template",
    "application/excel",
    "application/vnd.msexcel",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.template",
    "application/vnd.ms-excel.sheet.macroEnabled.12",
    "application/vnd.ms-excel.template.macroEnabled.12",
    "application/vnd.ms-excel.addin.macroEnabled.12",
    "application/vnd.ms-excel.sheet.binary.macroEnabled.12"
  ],
  /**
   * word file extension
   */
  word: [
    "application/msword",
    "application/vnd.ms-word.document.macroEnabled.12",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
  ],
  /**
   * Plain text file extension
   */
  text: ["text/plain"],
  /**
   * PDF file extension
   */
  pdf: ["application/pdf"],
  /**
   * image file extensions
   */
  image: ["image/jpeg", "image/pjpeg", "image/x-jps", "image/png"],
  /**
   * jpg file extensions
   */
  jpg: ["image/jpeg"],
  /**
   * png file extensions
   */
  png: ["image/png"],
  /**
   * csv file extensions
   */
  csv: [
    ".csv",
    "text/csv",
    "text/comma-separated-values",
    // works in Opera only for CSV
    "application/csv",
    "application/vnd.ms-excel",
    // Windows CSVs from Excel
    "application/vnd.msexcel"
    // Windows CSVs from Excel
  ]
};
export {
  p as FILE_ATTACHEMENT_FORMATS,
  a as FileMode
};
